import classnames from "classnames";
import { useEffect, useState } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import { CloseIcon } from "../../../constants/icons";
import { Button, TextField, TextGroup, TextLabel } from "../../Styled";
import "./attritionStyle.css";

const EditAttritionForm = (props) => {
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setErrors(props.errors);
  }, [props]);

  return (
    <div className="modalContent">
      <div className="modalHeader">
        <h4 className="modalTitle">Edit Attrition</h4>
        <span className="closeIcon" onClick={() => props.close(false)}>
          <CloseIcon />
        </span>
      </div>
      <Form className="w-100 white-form" onSubmit={props.submit}>
        {/* <Label className="fileUpload">
          <div className="avtarFile">
            <img src="./images/avtar.svg" alt="avtar" />
          </div>
          <Input type="file" name="avtar" accept="image/*" />
          <div className="avtarText">
            <h5>Edit Profile Pic</h5>
            <p>Image dimension (Minimum 200x200px, Less than 1 MB)</p>
          </div>
        </Label> */}
        <TextGroup className={classnames({ error: errors.package_case })}>
          <TextLabel>
            Package Name{" "}
            {Object.keys(props?.requiredField)?.includes("package_case")
              ? " *"
              : ""}
          </TextLabel>
          <TextField
            type="text"
            name="package_case"
            placeholder="Enter package name"
            value={props.fillData.package_case || ""}
            onChange={props.change}
          />
          {errors.package_case ? (
            <span className="error-text">{errors.package_case}</span>
          ) : null}
        </TextGroup>
        <TextGroup className={classnames({ error: errors.percentage })}>
          <TextLabel>
            Percentage (%){" "}
            {Object.keys(props?.requiredField)?.includes("percentage")
              ? " *"
              : ""}
          </TextLabel>
          <TextField
            type="number"
            name="percentage"
            placeholder="Enter percentage"
            min="1"
            max="100"
            step="any"
            value={props.fillData.percentage || ""}
            onChange={props.change}
            onWheel={(e) => e.target.blur()}
          />
          {errors.percentage ? (
            <span className="error-text">{errors.percentage}</span>
          ) : null}
        </TextGroup>
        <TextGroup className={classnames({ error: errors.count })}>
          <TextLabel>
            Count{" "}
            {Object.keys(props?.requiredField)?.includes("count") ? " *" : ""}
          </TextLabel>
          <TextField
            type="number"
            name="count"
            placeholder="Count"
            min="1"
            value={props.fillData.count || ""}
            onChange={props.change}
            onWheel={(e) => e.target.blur()}
          />
          {errors.count ? (
            <span className="error-text">{errors.count}</span>
          ) : null}
        </TextGroup>
        <TextGroup>
          <TextLabel>Lead Classification</TextLabel>
          <Row>
            <Col>
              <Label key={0} className="customRadio d-inline-block">
                <Input
                  type="radio"
                  name="lead_classification"
                  value="lead"
                  checked={
                    "lead" === props.fillData.lead_classification ? true : false
                  }
                  onChange={props.change}
                />
                <span className="span-text">Lead</span>
              </Label>
              <Label key={1} className="customRadio d-inline-block">
                <Input
                  type="radio"
                  name="lead_classification"
                  value="leadless"
                  checked={
                    "leadless" === props.fillData.lead_classification
                      ? true
                      : false
                  }
                  onChange={props.change}
                />
                <span className="span-text">Leadless</span>
              </Label>
              <Label key={2} className="customRadio d-inline-block">
                <Input
                  type="radio"
                  name="lead_classification"
                  value="unknown"
                  checked={
                    "unknown" === props.fillData.lead_classification
                      ? true
                      : false
                  }
                  onChange={props.change}
                />
                <span className="span-text">Unknown</span>
              </Label>
            </Col>
          </Row>
        </TextGroup>
        {/* <TextGroup>
          <TextLabel>Status</TextLabel>
          <InputSwitchUser>
            <input
              type="checkbox"
              className="custom-control-input"
              id="customSwitchesChecked"
              onChange={props.change}
              name="is_active"
              checked={props.fillData.is_active ? true : false}
            />
            <span className="span-text">Attrition Status</span>
          </InputSwitchUser>
        </TextGroup> */}
        <TextGroup>
          <Button className="importBtn blue px-5 w-auto" type="submit">
            Save Changes
          </Button>
        </TextGroup>
        <hr />
      </Form>
    </div>
  );
};

export default EditAttritionForm;
